<div class="table-wrapper" style="padding-bottom: 30px;">
  @if (koeffiziente) {
    <table class="hover-focus">
      <thead>
        <tr>
          <td class="no-border"><br><br></td>
          <th scope="colgroup" class="header bold centered border-bold-left" translate>
            m2.sprint9.cockpit-kontrolle.modellvarianten.koeffiziente.row-head.analysenurGrundlohn
          </th>
          <th scope="colgroup" class="header bold centered border-bold-left" translate>
            m2.sprint9.cockpit-kontrolle.modellvarianten.koeffiziente.row-head.analysemitFixerGewichtung
          </th>
          <th scope="col" class="header bold centered border-bold-left border-bold-right" translate>
            m2.sprint9.cockpit-kontrolle.modellvarianten.koeffiziente.row-head.standardAnalysemodell
          </th>
        </tr>
        <tr>
          <th scope="col" class="header border-bold-left p-2 centered bold" translate>
            m2.sprint9.cockpit-kontrolle.modellvarianten.koeffiziente.col-head.gewichtungFaktorenNormiert10
          </th>
          <td class="border-bold-left"></td>
          <td class="border-bold-left"></td>
          <td class="border-bold-left border-bold-right shaded"></td>
        </tr>
      </thead>
      <tbody>
        <tr appTableKoeffizienteDataRow [rowData]="koeffiziente.gewichtungAusbildung" [rowHeader]="rowHeaderResKeys.ausbildung"></tr>
        <tr appTableKoeffizienteDataRow [rowData]="koeffiziente.gewichtungAutonomie" [rowHeader]="rowHeaderResKeys.autonomie"></tr>
        <tr appTableKoeffizienteDataRow [rowData]="koeffiziente.gewichtungSpezifischesWissen" [rowHeader]="rowHeaderResKeys.spezifischesWissen"></tr>
        <tr appTableKoeffizienteDataRow [rowData]="koeffiziente.gewichtungVerantwortung" [rowHeader]="rowHeaderResKeys.verantwortung"></tr>
        <tr appTableKoeffizienteDataRow [rowData]="koeffiziente.gewichtungPsychosozial" [rowHeader]="rowHeaderResKeys.psychosozial"></tr>
        <tr appTableKoeffizienteDataRow [rowData]="koeffiziente.gewichtungKoerperlich" [rowHeader]="rowHeaderResKeys.koerperlich"></tr>
        <tr appTableKoeffizienteDataRow [rowHeader]="rowHeaderResKeys.korrelationskoeffizientOptimierteHead" [isHeader]="true"></tr>
        <tr appTableKoeffizienteDataRow [rowData]="koeffiziente.kendallTauB" [rowHeader]="rowHeaderResKeys.kendallTauB"></tr>
        <tr appTableKoeffizienteDataRow [rowData]="koeffiziente.pearson" [rowHeader]="rowHeaderResKeys.pearson"></tr>
        <tr appTableKoeffizienteDataRow [rowHeader]="rowHeaderResKeys.risikopaareProTestHead" [isHeader]="true"></tr>
        <tr appTableKoeffizienteDataRow [rowData]="koeffiziente.nurTest1" [rowHeader]="rowHeaderResKeys.nurTest1"></tr>
        <tr appTableKoeffizienteDataRow [rowData]="koeffiziente.nurTest2" [rowHeader]="rowHeaderResKeys.nurTest2"></tr>
        <tr appTableKoeffizienteDataRow [rowData]="koeffiziente.nurTest3" [rowHeader]="rowHeaderResKeys.nurTest3"></tr>
        <tr appTableKoeffizienteDataRow [rowData]="koeffiziente.test1Plus2" [rowHeader]="rowHeaderResKeys.test1Plus2"></tr>
        <tr appTableKoeffizienteDataRow [rowData]="koeffiziente.test1Plus3" [rowHeader]="rowHeaderResKeys.test1Plus3"></tr>
        <tr appTableKoeffizienteDataRow [rowData]="koeffiziente.test2Plus3" [rowHeader]="rowHeaderResKeys.test2Plus3"></tr>
        <tr appTableKoeffizienteDataRow [rowData]="koeffiziente.alleTests" [rowHeader]="rowHeaderResKeys.alleTests"></tr>
        <tr appTableKoeffizienteDataRow [rowHeader]="rowHeaderResKeys.regressionsergebnisTest2Head" [isHeader]="true"></tr>
        <tr appTableKoeffizienteDataRow [rowData]="koeffiziente.koeffizientKonstante" [rowHeader]="rowHeaderResKeys.koeffizientKonstante"></tr>
        <tr appTableKoeffizienteDataRow [rowData]="koeffiziente.koeffizientFunktionswert" [rowHeader]="rowHeaderResKeys.koeffizientFunktionswert"></tr>
        <tr appTableKoeffizienteDataRow [rowData]="koeffiziente.koeffizientAlter" [rowHeader]="rowHeaderResKeys.koeffizientAlter"></tr>
        <tr appTableKoeffizienteDataRow [rowData]="koeffiziente.koeffizientDienstjahre" [rowHeader]="rowHeaderResKeys.koeffizientDienstjahre"></tr>
        <tr appTableKoeffizienteDataRow [rowData]="koeffiziente.r2" [rowHeader]="rowHeaderResKeys.r2"></tr>
      </tbody>
      <tfoot>
        <tr>
          <td colspan="4" class="hint" translate>
          m2.sprint9.cockpit-kontrolle.modellvarianten.koeffiziente.basisGrundgesamtheit</td>
        </tr>
        <tfoot>
        </table>
      }
    </div>
